var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDinersClub = function SvgDinersClub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 35
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeOpacity: 0.2,
    strokeWidth: 1.083335,
    d: "M47.66 34.292h.005c2.07.017 3.767-1.675 3.793-3.783V4.514a3.88 3.88 0 0 0-1.127-2.708 3.73 3.73 0 0 0-2.67-1.098H4.335a3.72 3.72 0 0 0-2.666 1.098A3.87 3.87 0 0 0 .542 4.51v25.977a3.88 3.88 0 0 0 1.127 2.708 3.73 3.73 0 0 0 2.67 1.098zm-.002 1.083h-.002.005z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0165AC",
    d: "M21.671 4.612v-.034h8.667v.034c6.793.497 12.051 6.154 12.051 12.966s-5.258 12.468-12.051 12.965v.035H21.67v-.035C14.878 30.046 9.62 24.389 9.62 17.578c0-6.812 5.258-12.469 12.051-12.966"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M25.138 24.927a7.8 7.8 0 0 0 0-14.699zm-5.2-14.699a7.8 7.8 0 0 0 0 14.699zm2.6 18.616c-6.222 0-11.267-5.044-11.267-11.266S16.316 6.31 22.538 6.31s11.267 5.044 11.267 11.267-5.045 11.266-11.267 11.266"
  })));
};
export default SvgDinersClub;